export default "__VITE_ASSET__BSytx8ML__"